import { MantineProvider } from "@mantine/core";
import { ModalsProvider } from "@mantine/modals";
import { Notifications } from "@mantine/notifications";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { setStoreForAPI } from "./services/api";
import { store } from "./store/store";
import { theme } from "./theme/theme";

// Import Mantine styles
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";

// Set store reference for API service
setStoreForAPI(store);

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<Provider store={store}>
			<BrowserRouter>
				<MantineProvider theme={theme}>
					<ModalsProvider>
						<Notifications />
						<App />
					</ModalsProvider>
				</MantineProvider>
			</BrowserRouter>
		</Provider>
	</StrictMode>
);
